import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              精选文章
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              最新、最热门的大鸡巴养殖知识，助您成为养殖专家
            </p>
          </div>
          <Link
            to="/category/origin"
            className="mt-4 sm:mt-0 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}